import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getMenuCategory = async () => {
    const { data, error } = await supabase
        .from('menu_category')
        .select(`*`)

    if (error) {
        throw new Error(error.message)
    }

    return data
}

export default function useGetMenuCategories() {
    return useQuery({
        queryKey: ['useGetMenuCategories'],
        queryFn: () => getMenuCategory(),
        staleTime: 0,
    })
}
